module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vm-collapse-item",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.transform || _vm.transform && !_vm.isActive),
      expression: "!transform || transform&&!isActive"
    }],
    staticClass: "vm-collapse-item__header",
    on: {
      "click": function($event) {
        _vm.handleClick('header')
      }
    }
  }, [_vm._t("header", [_c('i', {
    staticClass: "vm-collapse-item__header__arrow vm-collapse-icon--arrow-right"
  }), _vm._v(" "), _vm._t("title", [_vm._v(_vm._s(_vm.title))])])], 2), _vm._v(" "), _c('vm-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "vm-collapse-item__wrap",
    on: {
      "click": function($event) {
        _vm.handleClick('content')
      }
    }
  }, [_c('div', {
    staticClass: "vm-collapse-item__content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6dfca6c9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dfca6c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collapse-item.vue
// module id = 27
// module chunks = 0